var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkCoalBurned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #92a5a8;\n      }\n\n      .cls-2 {\n        fill: #02222b;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke-width: 3px;\n      }\n\n      .cls-4, .cls-5 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-5 {\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.8 70.3 39.9 34.7 48.9 34.7 49 70.3 39.8 70.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.7,
    y: 29.3,
    width: 10.8,
    height: 41.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4,
    y1: 69.6,
    x2: 71.4,
    y2: 69.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.9,69.6s.3-15.7,0-20.2,0-14.7,0-14.7h-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.3,34.7h-4.4s.3,10.1,0,14.7c-.3,4.5,0,20.2,0,20.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 37.3,
    y1: 39.5,
    x2: 51.2,
    y2: 39.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.9,31.5s-2.7,1.1-3.6-3,1.5-5.7,1.5-5.7c0,0,3-8.3,8.9-12.7s8.4,1.5,8.4,1.5c0,0,3.1-4.6,7.6.3,4.5,4.9,0,7.7,0,7.7,0,0,2.8,7.7-3.6,8.3-.6,6.1-11,3.8-11,3.8h-8v-.2s-.2,0-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.3,69.6s.3-18.1,0-23.4,0-17,0-17h-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.9,29.3h-5.1s.3,11.7,0,17,0,23.4,0,23.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 16.9,
    y1: 34.6,
    x2: 33,
    y2: 34.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.6,26s-2.7-.9-2.4-4.4,3.3-3.8,3.3-3.8c0,0-1.1-5.5,1.8-7.8s6.7-.6,6.7-.6c0,0-.5-4.3,3.9-5.5s6.3,1.9,6.3,1.9c0,0,4.6-3.4,8,.6s-.2,7.8-.2,7.8c0,0,3.4,2.9.2,7.6s-6.8,1.1-6.8,1.1c0,0-2.1,5.2-10,3.1.2.2-10.8,0-10.8,0Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCoalBurned);
export default __webpack_public_path__ + "static/media/dark-coalBurned.f4ed7761a6b80af7cfb3a1c024d001ef.svg";
export { ForwardRef as ReactComponent };